module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/8f0d918e4e6159363fdbe16ef4d61167.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/btn_standard_dropdown.svg
// module id = bC5U
// module chunks = 0